var exports = {
  "$e": "xfd349460--e16636--warning",
  "R8": "xfd349460--e16636--warn",
  "Pf": "xfd349460--e16636--label",
};

module.exports = exports;
